import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

export default function PaywallListener() {
  const nav = useNavigate();
  useEffect(() => {
    const h = (e) => {
      toast.error(e.detail || "Advanced feature locked", {
        description: "Subscribe to unlock",
        action: { label: "Upgrade", onClick: () => nav("/billing") },
      });
    };
    window.addEventListener("tj:paywall", h);
    return () => window.removeEventListener("tj:paywall", h);
  }, [nav]);
  return null;
}
